import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators, compose } from 'redux';

import OrderSideComponent from '../../components/OrderSideComponent';

import { selectClient, selectTermsAndConditionsUrl } from '../../global-selectors';
import { selectUserData } from '../../queries/selectors/user';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { selectShoppingCartConfig } from '../../queries/selectors/shoppingCart';
import {
  selectBootstrapConfig,
  selectCouponApply,
  selectSingleSubscriptionClient,
  selectSubscriberConfig
} from '../../queries/selectors/bootstrap';
import { selectHiddenCouponInput } from '../../queries/selectors/coupon';
import {selectActivePlanSubscription} from "../../queries/selectors/products";
import { setTotalPriceSummary } from '../../queries/actions/payment';

const mapStateToProps = (state) => {
  const stateErrors = state.errors || {};
  const couponVerifyEntry = Object.entries(stateErrors).find(
    ([key]) => key.includes('/admin/coupon/verify')
  );
  const couponApply = selectCouponApply(state);

  return {
    client: selectClient(state),
    config: selectBootstrapConfig(state),
    userData: selectUserData(state),
    couponApply,
    subscriber: selectSubscriberConfig(state),
    shoppingCart: selectShoppingCartConfig(state),
    paymentMethod: selectCurrentPaymentMethod(state),
    hiddenCoupon: selectHiddenCouponInput(state),
    isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
    planSubscription: selectActivePlanSubscription(state),
    couponVerifyError: (!couponApply?.errorDismissed && couponVerifyEntry)
      ? couponVerifyEntry[1]?.responseBody ?? null
      : null,
    termsAndConditionsUrl: selectTermsAndConditionsUrl(state),
  };
};

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    setTotalPriceSummary: payload => dispatch(setTotalPriceSummary(payload)),
  }, dispatch)
);

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderSideComponent);
